import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, Send, History, Settings, Lock } from "lucide-react";
import { storage } from "@/lib/storage";

const TABS = [
  { id: "home", label: "Home", icon: Home, path: "/merchant", match: ["/merchant", "/receive", "/online-pay", "/wallet", "/plans", "/assistant"] },
  { id: "pay", label: "Pay", icon: Send, path: "/customer", match: ["/customer"] },
  { id: "history", label: "History", icon: History, path: "/history", match: ["/history"] },
  { id: "settings", label: "Settings", icon: Settings, path: "/settings", match: ["/settings"] },
];

export const BottomNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isActive = (tab) => tab.match.some((p) => pathname === p || pathname.startsWith(p + "/"));

  const lock = () => {
    storage.lock();
    navigate("/", { replace: true });
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 pb-safe px-3"
      data-testid="bottom-nav"
      style={{ pointerEvents: "none" }}
    >
      <div
        className="mx-auto max-w-[560px] mb-3 rounded-2xl flex items-center justify-around px-2 py-2"
        style={{
          background: "linear-gradient(145deg, rgba(16,22,42,0.92) 0%, rgba(10,15,30,0.92) 100%)",
          backdropFilter: "blur(18px)",
          WebkitBackdropFilter: "blur(18px)",
          border: "1px solid rgba(230,180,85,0.2)",
          boxShadow: "0 10px 40px -8px rgba(0,0,0,0.5), 0 0 0 1px rgba(230,180,85,0.08) inset",
          pointerEvents: "auto",
        }}
      >
        {TABS.map((tab) => {
          const active = isActive(tab);
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className="flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-xl transition"
              data-testid={`nav-${tab.id}`}
              aria-label={tab.label}
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center transition ${
                  active
                    ? "bg-[rgba(230,180,85,0.15)] text-[#E6B455]"
                    : "text-[#F7E6B4]/55 hover:text-[#F7E6B4]/85"
                }`}
              >
                <Icon size={20} />
              </div>
              <span
                className={`text-[10px] font-semibold tracking-wide ${
                  active ? "text-[#E6B455]" : "text-[#F7E6B4]/50"
                }`}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
        <button
          onClick={lock}
          className="flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-xl transition"
          data-testid="nav-lock"
          aria-label="Lock"
        >
          <div className="w-10 h-10 rounded-xl flex items-center justify-center text-[#F7E6B4]/55 hover:text-[#F7E6B4]/85 transition">
            <Lock size={20} />
          </div>
          <span className="text-[10px] font-semibold tracking-wide text-[#F7E6B4]/50">Lock</span>
        </button>
      </div>
    </nav>
  );
};
